import * as React from 'react';
export const vanlanschotSvg = React.forwardRef(function vanlanschotSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#2F8E38',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.953 32c-.01-1.721-.042-3.444-.006-5.164 0-.227.318-.506.553-.66 1.432-.93 2.62-2.068 3.205-3.728.31-.878.491-1.768.267-2.688a2.634 2.634 0 0 0-.478-1.002c-.318-.396-.31-.755-.15-1.198.207-.58.414-1.171.494-1.774.092-.705-.206-1.317-.785-1.758-.283-.215-.347-.439-.271-.8.124-.657.21-1.321.255-1.989.067-.775-.31-1.304-1.034-1.535-.468-.149-.593-.425-.596-.879.001-.586-.044-1.17-.136-1.749-.19-1.129-.827-2.114-2.029-2.075-1.202.04-2.032.724-2.256 2.055-.11.66-.11 1.338-.193 2.004-.023.179-.126.413-.268.502-1.366.827-1.574 1.275-1.25 2.852.061.303.178.603.19.907.007.207-.061.517-.207.612-1.089.684-1.185 1.706-.79 2.725.378.975.414 1.715-.134 2.705-.881 1.58-.141 3.111.772 4.486.723 1.086 1.775 1.823 2.88 2.47.405.238.531.555.53.974 0 1.567-.004 3.135-.012 4.704l1.45.003Z',
      fill: '#fff',
    }),
  );
});
vanlanschotSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var vanlanschot = {
  category: 'brand',
  colorable: false,
  name: 'vanlanschot',
  svg: vanlanschotSvg,
};
